// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1YO8c","selected":"Chip_selected__YYMMd"};